export default __webpack_public_path__ + "media/images/superstars_2-c71d1cf0bd98be248a1143531459e5e4.png";